/**
 * 使用 BootstrapUI 类创建各种 Bootstrap 组件
 */

import { BootstrapUI, bootstrapUI } from '../base/bootstrapui';

export class BaseUITools {
    private domid: string;
    protected ui: BootstrapUI;
    protected children: Record<string, HTMLElement> = {};
    protected container: HTMLElement;

    constructor(containerId: string, withInit: boolean = true) {
        this.domid = containerId;
        this.ui = bootstrapUI;
        if (containerId) {
            if (document.getElementById(containerId)) {
                this.container = document.getElementById(containerId) as HTMLElement;
            } else {
                const newContainer = document.createElement('div');
                newContainer.id = containerId;
                document.body.appendChild(newContainer);
                this.container = newContainer;
            }
        } else {
            this.container = document.body;
        }
        if (withInit) {
            this.init();
        }
    }
    init(): void {
        // 初始化方法，子类可以重写
    }

    // 添加子元素
    appendChild(name, child: HTMLElement): void {
        this.children[name] = child;
        this.container.appendChild(child);
    }

    appendExistChild(name: string, child: HTMLElement): void { // 添加已存在子元素（不添加到容器中），仅为了便于控制元素
        this.children[name] = child;
    }

    // 获取子元素
    getChild(name: string): HTMLElement {
        return this.children[name];
    }

    // 删除子元素
    removeChild(name: string): void {
        delete this.children[name];
        this.container.removeChild(this.children[name]);
    }
    getChildren(): Record<string, HTMLElement> {
        return this.children;
    }
    registerEvent(name: string, event: string, handler: EventListener): void {
        this.ui.on(event, this.children[name], handler);
    }

    unregisterEvent(name: string, event: string, handler: EventListener): void {
        this.ui.off(event, this.children[name], handler);
    }

    registerChildEvent(name: string, event: string, handler: EventListener): void {
        this.ui.on(event, this.children[name], handler);
    }

    unregisterChildEvent(name: string, event: string, handler: EventListener): void {
        this.ui.off(event, this.children[name], handler);
    }
    getContainer(): HTMLElement {
        return this.container;
    }
    destroy(): void {
        this.ui.cleanup();
        this.container.innerHTML = '';
    }

}


